import errors from './errors/index.js';
import translation from './translation/index.js';
const en = Object.freeze({
    translation,
    errors,
});
export default en;
